import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // 🔹 IMPORTANTE
import Pesquisa from "../Pesquisa/Pesquisa";
import logo from "../../img/logo - senai-ited.svg";

function Menu({ texto, onTextoChange, onPesquisar, aoIrHome }) {

  const [mostraBuscaMenu, setMostrarBuscaMenu] = useState(false);

  /* 🔹 Hook de navegação do React Router */
  const navegar = useNavigate();

  const secoes = [
    { titulo: "Realidade Virtual", id: "secao-rv" },
    { titulo: "Realidade Aumentada", id: "secao-ra" },
    { titulo: "Vídeo 360", id: "secao-video360" },
    { titulo: "Vídeo 360i", id: "secao-video360i" },
  ];

  function irParaSecao(id) {

    /* 🔹 limpa pesquisa primeiro */
    if (aoIrHome) {
      aoIrHome();
    }

    if (window.location.pathname === "/") {
      const elemento = document.getElementById(id);

      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navegar("/#" + id);
  }

  /* 🔹 Função para voltar à página inicial */
  function irParaInicio() {
    navegar("/");

    /* opcional: rolar para o topo */
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <nav
      className="menu"
      onMouseEnter={() => setMostrarBuscaMenu(false)} // Desativado a barra de busca do menu temporariamente. Basta colocar TRUE aqui
      onMouseLeave={() => setMostrarBuscaMenu(false)}
    >
      <div className="container menu-container">
        {/* Logo clicável */}
        <div
          className="espacoLogo"
          onClick={irParaInicio}
          style={{ cursor: "pointer" }} // feedback visual de clique
        >
          <img src={logo} alt="Logo Senai ITED" />
        </div>

        {/* Área direita (botões + busca) */}
        <div className="menu-direita">

          {/* Botões */}
          <div className="espacoBotoes">
            {secoes.map(function (sec) {
              return (
                <button
                  key={sec.id}
                  onClick={() => irParaSecao(sec.id)}
                  className="botoesMenu"
                >
                  {sec.titulo}
                </button>
              );
            })}
          </div>

          {/* Barra de busca */}
          <div className={`busca-menu ${mostraBuscaMenu ? "ativa" : ""}`}>
            <Pesquisa
              texto={texto}
              onTextoChange={onTextoChange}
              onPesquisar={onPesquisar}
            />
          </div>

        </div>
      </div>
    </nav>
  );
}

export default Menu;
